import { Translate } from 'react-localize-redux'

export default [
  { value: 'warmup', title: <Translate id="training.warmup-drill" /> },
  { value: 'main_part', title: <Translate id="training.main-part-drill" /> },
  { value: 'final_part', title: <Translate id="training.final-part-drill" /> },
]
